<template>
<div>

    <b-card no-body border-variant="light">
        <div slot="header">
            <strong>Wireless Associated Hosts</strong> updated {{relativeTime(device.status.wireless.hosts.ts)}}
            <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'wifiClients', 3000)">
                <b-overlay :show="busy" rounded spinner-small spinner-variant="primary">
                    <i class="fa fa-refresh"></i>
                </b-overlay>
            </b-button>
        </div>

        <b-table small hover :fields="fields" :items="device.status.wireless.hosts.data" responsive="sm" primary-key="client_ip">
            <template #cell(index)="data">{{ data.index + 1 }}</template>
        </b-table>

    </b-card>

</div>
</template>

<script>
import moment from 'moment';
export default {

    props: {
        device: {},
    },
    data() {
        return {
            busy: false,
            timer: false,
            fields: [
                { key: 'index', label: '#' },
                { key: 'client_id', label: 'Client MAC', sortable: true },
                { key: 'signal', label: 'Signal', sortable: true },
                { key: 'noise', sortable: true },
                { key: 'inactive', label: 'In Active (m secs)', sortable: true },

                { key: 'rx.rate', label: 'RX Rate', sortable: true },
                { key: 'rx.rate', label: 'RX', sortable: true },
                { key: 'rx.bytes', label: 'RX Bytes', sortable: true },
                { key: 'rx.packets', label: 'RX Packets', sortable: true },

                { key: 'tx.rate', label: 'TX Rate', sortable: true },
                { key: 'tx.rate', label: 'TX', sortable: true },
                { key: 'tx.bytes', label: 'TX Bytes', sortable: true },
                { key: 'tx.packets', label: 'TX Packets', sortable: true },

            ]
        }
    },
    created() {
        this.timer = setInterval(this.enableTimer, 1000);
    },
    methods: {

        enableTimer() {
            this.timer = true;
        },
        relativeTime(value) {
            let localTime = moment.unix(value).local();
            return (value == null) ? '-' : moment(localTime).fromNow()
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
        },
        sendCmd(id, op, wait) {
            this.busy = true;
            let uri = `/api/devices/${this.device.id}/op?op=${op}`;
            axios.get(uri).then((response) => {
                if (response.data.success === true) {
                    let msg = 'Request sent.' + ' Wait ' + wait / 1000 + ' seconds.';
                    this.makeToast('info', msg);
                    this.stReturn = setTimeout(() => {
                        this.$emit('childgetData_event');
                        this.busy = false;
                    }, wait);
                } else {
                    this.makeToast('danger', 'Unable to contact device.');
                }
            });
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
    }

}
</script>
